import { propertyManagementCopilot } from 'src/lib/network/api/ai/agents/propertyManagementCopilot';

export const ai = {
  propertyManagementCopilot
};
